window.addEventListener('DOMContentLoaded', () => {
  const interval = setInterval(() => {
    if (window.Swiper) {
      clearInterval(interval);

      document.querySelectorAll('.article-image-swiper').forEach((elem) => {
        new Swiper(elem, {
          breakpoints: {
            1280: {
              // slidesPerGroup: 2,
              // slidesPerView: 3,
            },
          },
          slidesPerGroup: 1,
          slidesPerView: 'auto',
          spaceBetween: 16,
          navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
          },
        });
      });

      document.querySelectorAll('.article-main-swiper').forEach((elem) => {
        new Swiper(elem, {
          breakpoints: {
            1280: {
              slidesPerGroup: 2,
              slidesPerView: 3,
              spaceBetween: 16,
            },
          },
          // loop: true,
          slidesPerGroup: 1,
          slidesPerView: 'auto',
          spaceBetween: 8,
          navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
          },
        });
      });
    }
  }, 200);
});